import { Typography, Box } from '@mui/material'
import React from 'react'

function TextBox({customStyles, propText, ...props}) {
    const containerStyles = {
        backgroundColor: '#ECECEC', 
        display: 'flex', 
        paddingX: '10px', 
        paddingY: '5px',
        minWidth: '130px',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
    }

    return (
        <Box sx={{...containerStyles, ...customStyles}}>
            <Typography variant='body2'>{propText}</Typography>
        </Box>
    )
}

export default TextBox